import { Widget, WidgetHeader } from './shared';
import t from '../../../util/translation/translation';
import { Link } from 'react-router-dom';
import UpcomingGamesList from '../../../containers/match_center/UpcomingGamesList';

const UpcomingGames = () => {
  return (
    <Widget>
      <WidgetHeader
        bottomSpace="sm"
        title={t('DashboardPage.upcomingGames')}
        subhead={''}
      >
        <Link to="/matches/upcoming" className="events-link">
          {t('DashboardPage.viewAll')}
        </Link>
      </WidgetHeader>
      <UpcomingGamesList />
    </Widget>
  );
};

export default UpcomingGames;
